import * as React from 'react';
import { Button } from 'reactstrap';
import Octicon, { ChevronUp, ChevronDown } from '@githubprimer/octicons-react';
import { GetToggleButtonPropsOptions } from 'downshift';

export interface AutoSuggestMenuToggleProps {
	isOpen: boolean;
	disabled: boolean;
	getToggleButtonProps: (options?: GetToggleButtonPropsOptions) => any;
}

/**
 * Renders the button to expand/collapse the menu on the AutoSuggestInput.
 *
 * @class AutoSuggestMenuToggle
 * @extends {React.Component<AutoSuggestMenuToggleProps>}
 */
class AutoSuggestMenuToggle extends React.Component<AutoSuggestMenuToggleProps> {
	public render() {
		const { getToggleButtonProps, isOpen, disabled } = this.props;

		return (
			<Button
				color="primary"
				data-testid="autosuggest-menu-toggle-btn"
				className="btn-input btn-autosuggest-toggle"
				{...getToggleButtonProps()}
				title="Toggle"
				disabled={disabled}
			>
				{isOpen ? (
					<Octicon icon={ChevronUp} ariaLabel="Chevron Up" />
				) : (
					<Octicon icon={ChevronDown} ariaLabel="Chevron Down" />
				)}
			</Button>
		);
	}
}

export default AutoSuggestMenuToggle;
